import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { AdminAdminDetailQueryDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminAdminDetailQueryResultFragment, AdminAdminDetailQueryParams } from '@docpace/admin-graphql'

const typedAdminAdminDetailQueryDocument = AdminAdminDetailQueryDocument as TypedDocumentNode<AdminAdminDetailQueryResultFragment, Partial<AdminAdminDetailQueryParams>>

export function useAdminAdminDetailQuery(opts?: useQuery.Options<AdminAdminDetailQueryResultFragment, Partial<AdminAdminDetailQueryParams>>){
    return useQuery(typedAdminAdminDetailQueryDocument, opts)
}
